import React from 'react'
import cn from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import SvgIcon from '@material-ui/core/SvgIcon'

const style = {
  root: {
    width: '16px',
    height: '15px',
  },
}

const UndoActiveIcon = ({ classes, className, ...props }) => (
  <SvgIcon
    {...props}
    className={cn(classes.root, className)}
    fill="none"
    viewBox="0 0 16 12"
  >
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.79273 0.0187445C4.75658 0.0315943 4.70729 0.0551519 4.68319 0.0722857C4.61528 0.118332 1.07944 3.58355 1.04658 3.63602C0.960044 3.77202 0.970998 3.95299 1.07177 4.08363C1.14297 4.17572 4.54408 8.15815 4.59885 8.21384C4.76206 8.37981 5.0359 8.37339 5.19254 8.20099C5.22212 8.16886 5.25717 8.11532 5.27141 8.08212L5.29551 8.02323L5.29879 6.87101L5.30208 5.71772L5.32618 5.7113C5.38971 5.69631 5.75337 5.65026 5.92534 5.63634C7.01961 5.54532 8.11607 5.70594 9.14353 6.10751C10.5675 6.66327 11.8425 7.69555 12.8919 9.14225C13.3585 9.78582 13.7736 10.4958 14.1888 11.3589C14.2666 11.5184 14.3191 11.5795 14.4243 11.6298C14.4889 11.6598 14.5064 11.6641 14.5952 11.6641C14.6828 11.6641 14.7014 11.6608 14.7649 11.6309C14.8931 11.5709 14.9851 11.4478 15.0015 11.316C15.0125 11.225 14.9205 10.5954 14.8241 10.0899C14.3279 7.50816 13.2895 5.53247 11.7417 4.2314C10.5796 3.2548 9.149 2.66156 7.52458 2.48273C7.18282 2.44418 7.05466 2.43669 6.63514 2.43133C6.14332 2.42384 5.80814 2.4399 5.38642 2.48809L5.32289 2.49558L5.3207 1.39369L5.31741 0.291806L5.28127 0.22006C5.21554 0.0883474 5.09286 0.0112486 4.93403 0.00161076C4.87488 -0.0026722 4.84312 0.00161076 4.79273 0.0187445Z"
        fill="#4A4A4A"
      />
    </svg>
  </SvgIcon>
)

export default withStyles(style)(UndoActiveIcon)
